import { createRoot } from 'react-dom/client'
import HttpsRedirect from 'react-https-redirect'

import App from '@/App'
import keys from '@/config/keys'
import preloadImage from '@/utils/preloadImage'
import axiosReqInterceptor from '@/utils/axiosReqInterceptor'
import axiosResInterceptor from '@/utils/axiosResInterceptor'
import setAxiosDefaultHeader from '@/utils/setAxiosDefaultHeader'

import { HEADERS } from './dev'

// Load the logo
preloadImage(localStorage.getItem(keys.SPLASH_LOGO))

// Axios - AJAX Related
setAxiosDefaultHeader(true, HEADERS)
axiosReqInterceptor()
axiosResInterceptor()

const root = createRoot(document.getElementById('root'))
root.render(
	<HttpsRedirect>
		<App />
	</HttpsRedirect>,
)
